import React, { lazy } from "react";
import { useSelector } from "react-redux";
import {
  Route,
  Routes,
  Navigate,
  BrowserRouter
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AuthenticatedLayout from "../layouts/AuthenticatedLayout";
import UnauthenticatedLayout from "../layouts/UnauthenticatedLayout";
import { getDefaultRoute, LocalUtils, USER_TYPES } from "../util";
import { customerFacingRoutes, publicRoutes , bookAppointmentRoute , bookServicesRoute , employeeRoutes } from "./index";
import { getRoutes } from "./index";
import RouteProtection from "./RouteProtection";

const Login = lazy(() => import("../views/auth/Login"));
function RootRoutes() {
  const { permissions, role, id } = useSelector((state) => state.user);
  return (
    <BrowserRouter>
      <ToastContainer />
      <Routes>
        {customerFacingRoutes.map(({ component, path, title, showHeader = false , additionalClass = null }, key) => (
          <Route
            path={path}
            element={
              <UnauthenticatedLayout title={title} showHeader={showHeader} additionalClass={additionalClass}>
                {component}
              </UnauthenticatedLayout>
            }
            key={key}
          />
        ))}

        {publicRoutes.map(({ component, path, title, showHeader = false , additionalClass = null  }, key) => (
          <Route
            path={path}
            element={(function () {
              const token = LocalUtils.getToken();
              if (!!token && role !== USER_TYPES.BOOK_CUSTOMER) {
                return <Navigate to={getDefaultRoute(role)} />;
              } else {
                return (
                  <UnauthenticatedLayout title={title} showHeader={showHeader} additionalClass={additionalClass}>
                    {component}
                  </UnauthenticatedLayout>
                );
              }
            })()}
            key={key}
          />
        ))}
        
        {bookAppointmentRoute.map(({ component, path, title, showHeader = false , additionalClass = null }, key) => (
            <Route
              path={path}
              element={(function () {
            	  return ( <UnauthenticatedLayout title={title} showHeader={showHeader} additionalClass={additionalClass}> {component} </UnauthenticatedLayout>);
                
              })()}
              key={key}
            />
        ))}

        {bookServicesRoute.map(({ component, path, title, showHeader = false , additionalClass = null }, key) => (
            <Route
              path={path}
              element={(function () {
            	  return ( <UnauthenticatedLayout title={title} showHeader={showHeader}> {component} </UnauthenticatedLayout>);
                
              })()}
              key={key}
            />
        ))}

        {getRoutes(permissions).map(
          ({ component, path, title, pageAccess = false , showSideBar = true , topAlignHeader = null }, key) => (
            <Route
              path={path}
              element={
                <AuthenticatedLayout title={title} showSidebar={showSideBar} topAlignHeader={topAlignHeader} >
                  <RouteProtection pageAccess={pageAccess}>
                    {component}
                  </RouteProtection>
                </AuthenticatedLayout>
              }
              key={key}
            />
          )
        )}

        {employeeRoutes.map(({ component, path, title, showHeader = false , additionalClass = null }, key) => (
          <Route
            path={path}
            element={
              <UnauthenticatedLayout title={title} showHeader={showHeader} additionalClass={additionalClass}>
                {component}
              </UnauthenticatedLayout>
            }
            key={key}
          />
        ))}

        <Route path="/login" element={<Login />} />

        <Route
          path="*"
          element={(function () {
            if (role === USER_TYPES.ADMIN) {
              return <Navigate to="/billings" />;
            } else if (role === USER_TYPES.CUSTOMER) {
              return <Navigate to="/user" />;
            } else if (role === USER_TYPES.EMPLOYEE) {
              return <Navigate to="/welcome" />;
            }
            return <Navigate to="/" />;
          })()}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default RootRoutes;
